import { render } from "./FormSelect.vue?vue&type=template&id=54debbf4&scoped=true"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"

import "./FormSelect.vue?vue&type=style&index=0&id=54debbf4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54debbf4"]])

export default __exports__